import React from 'react';
import { Box, Typography, Button, IconButton } from '@mui/material';
import styled from '@emotion/styled';
import { Close } from '@mui/icons-material';

const InputStyled = styled('input')({
  display: 'none',
});

const ImageUploadField = ({
  label,
  name,
  formik,
  data = [],
  sx = {},
  imageHeight = '100px',
  imageWidth = '150px',
  multiple = false,
}) => {
  const handleImageChange = (event) => {
    const files = Array.from(event.target.files);

    if (files.length > 0) {
      if (multiple) {
        const currentValue = formik.values[name] || [];
        const currentImages = Array.isArray(currentValue) ? currentValue : [];
        const newImages = [...currentImages, ...files];
        formik.setFieldValue(name, newImages);
      } else {
        formik.setFieldValue(name, files[0]);
      }
    }
  };

  const removeImage = (index) => {
    if (multiple) {
      const currentValue = formik.values[name] || [];
      const currentImages = Array.isArray(currentValue) ? currentValue : [];
      const newImages = [...currentImages];
      newImages.splice(index, 1);
      formik.setFieldValue(name, newImages);
    } else {
      formik.setFieldValue(name, null);
    }
  };

  const getAllImages = () => {
    const existingImages = Array.isArray(data?.images) ? data.images : [];
    const uploadedImages = formik.values[name] 
      ? (Array.isArray(formik.values[name]) ? formik.values[name] : [formik.values[name]]) 
      : [];
    return [ ...uploadedImages, ...existingImages];
  };

  const getImageUrl = (image) => {
    if (!image) return '';
    if (image instanceof File) {
      return URL.createObjectURL(image);
    }
    if (typeof image === 'object' && image.url) {
      return image.url;
    }
    return image;
  };

  return (
    <Box sx={{ ...sx }}>
      <Typography variant="body1" sx={{ color: '#ADADAD' }}>{label}</Typography>
      <Box
        sx={{
          border: '1px dashed #9A9AA9',
          textAlign: 'center',
          my: 1,
          p: 1,
          height: '180px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '10px',
          backgroundColor: '#F5F6FA',
        }}
      >
        <label htmlFor={`file-upload-${name}`}>
          <InputStyled
            id={`file-upload-${name}`}
            type="file"
            multiple={multiple}
            onChange={handleImageChange}
            accept="image/*"
          />
          <Button
            component="span"
            sx={{
              backgroundColor: '#01A0E2',
              borderRadius: 0,
              px: 3,
              color: '#fff',
              fontSize: '16px',
            }}
          >
            {multiple ? 'Upload Images' : 'Upload Image'}
          </Button>
        </label>
      </Box>

      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mt: 2 }}>
        {getAllImages().map((image, index) => (
          <Box key={index} sx={{ position: 'relative' }}>
            <img
              src={getImageUrl(image)}
              alt="Selected"
              style={{
                width: imageWidth,
                height: imageHeight,
                borderRadius: '6px',
                objectFit: 'cover',
              }}
            />
            {(index >= (Array.isArray(data?.images) ? data.images.length : 0)) && (
              <IconButton
                size="small"
                onClick={() => removeImage(index - (Array.isArray(data?.images) ? data.images.length : 0))}
                sx={{
                  position: 'absolute',
                  top: 0,
                  right: 0,
                  backgroundColor: 'rgba(255,255,255,0.7)',
                  borderRadius: '50%',
                }}
              >
                <Close fontSize="small" />
              </IconButton>
            )}
          </Box>
        ))}
      </Box>

      {formik.touched[name] && formik.errors[name] && (
        <Typography color="error" variant="body2" mt={1}>
          {formik.errors[name]}
        </Typography>
      )}
    </Box>
  );
};

export default ImageUploadField;